import styles from "../ResourceMonitor.module.scss";
import {
  CalendarIconDate,
  AddPersonIcon,
  FilterCross,
} from "../../../../modules/default-svg";
import ShiftCell from "../../../../components/shiftsCell/ShiftCell";
import CustomPopover from "../../../../components/popover/Popover";
import CustomInput from "../../../../components/controls/input/customInput/CustomInput";
import CustomButton from "../../../../components/controls/button/Button";
import service from "../../../../store/services/user.service";
import {
  TeachingPopover,
  Avatar,
  Button,
  TeachingPopoverBody,
  TeachingPopoverHeader,
  TeachingPopoverSurface,
  TeachingPopoverTrigger,
  Tooltip,
} from "@fluentui/react-components";
import { useState } from "react";
import AddCapacity from "../../../scopeOverview/AddCapacity";
// import HourlyEstimation from "../../../../components/hourlyEstimation/HourlyEstimation";

const TaskCard = ({ item = null, assignShift = true }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [resourceOptions, setResourceOptions] = useState([]);
  const [selectedResources, setSelectedResources] = useState([]);
  const [assignedResources, setAssignedResources] = useState([]);
  const searchHandler = (value) => {
    // if (value) {
    service.searchUserDataRequest(value).then((res) => {
      const transformedArray = res.map((obj) => ({
        label: obj.name,
        value: obj.id,
      }));
      setResourceOptions(transformedArray);
    });
    // }
  };
  const handleInputChange = (id, value) => {
    setSelectedResources((prevState) =>
      prevState.map((resource) =>
        resource.value === id ? { ...resource, capacity: value } : resource
      )
    );
  };
  const handleActiveChange = (id, isActive) => {
    setSelectedResources((prevState) => {
      if (isActive) {
        const newResource = resourceOptions.find(
          (resource) => resource.value === id
        );
        return [...prevState, { ...newResource, inputValue: "" }];
      } else {
        return prevState.filter((resource) => resource.value !== id);
      }
    });
  };
  const handleCancelResource = () => {
    setAssignedResources([]);
    setIsPopoverOpen(false);
  };
  const handleConfirm = () => {
    // Create a new array that includes only unique resources
    const newAssignedResources = [
      ...assignedResources,
      ...selectedResources.filter(
        (selectedResource) =>
          !assignedResources.some(
            (assignedResource) =>
              assignedResource.value === selectedResource.value
          )
      ),
    ];

    setAssignedResources(newAssignedResources);
    setIsPopoverOpen(false);
  };

  const handleAssigneResource = (resource) => {
    setAssignedResources((prevSelectedResource) => {
      if (prevSelectedResource.some((res) => res.value === resource.value)) {
        return prevSelectedResource.filter(
          (res) => res.value !== resource.value
        );
      } else {
        return [...prevSelectedResource, { name: resource }];
      }
    });
  };

  const getPriority = (priority) => {
    switch (priority) {
      case 0:
        return "Low";
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "";
    }
  };

  const getPriorityPill = (priority) => {
    switch (priority) {
      case 0:
        return "pill success";
      case 1:
        return "pill orange";
      case 2:
        return "pill warning";
      default:
        return "";
    }
  };
  return (
    <div className="col-6">
      <div
        className={`${styles.cardTask} ${
          item.status < 2 ? styles.cardWhite : styles.cardRed
        }`}
      >
        <div className="d-flex align-items-start mb-12 justify-content-between">
          <div>
            <div className="d-flex align-items-center mb-1">
              <span className="text-xxsm-400 grey36Color">
                {item.refId} ·&nbsp;
              </span>
              <span className="text-xxsm-400 grey36Color">Planning</span>
            </div>
            <p className="text-sm-400 heading-color">{item.name}</p>
          </div>
          <Tooltip
            content="Capacity Utilized"
            relationship="label"
            withArrow
            positioning="after"
          >
            <div className="CapacityWeekly">{item.allocatedEffort}hrs</div>
          </Tooltip>
        </div>

        <div className={`${styles.statPills} d-flex mb-3`}>
          <span className={getPriorityPill(item.status)}>
            {getPriority(item.status)}
          </span>

          {item?.startDate && item?.endDate && (
            <div className="d-flex align-items-center">
              <CalendarIconDate />

              <p className="text-xxsm-400 ms-1">
                <span className={`${styles.startDatetext}`}>
                  {item.startDate.split("T")[0].split("-").join("/")}
                </span>{" "}
                -{" "}
                <span className={`${styles.startDatetext}`}>
                  {item.endDate.split("T")[0].split("-").join("/")}
                </span>
              </p>
            </div>
          )}
        </div>

        <div className="d-flex flex-wrap align-items-center gap-2">
          {(item.allocations.length > 2
            ? item.allocations.slice(0, 2)
            : item.allocations
          ).map((data) => (
            <div className="AssignToChip large">
              <Avatar
                color="colorful"
                size={32}
                img={{ src: data.resource.image }}
                name={data.resource.name}
              />
              <div className="assignToInfo">
                <p className="text-xsm-400">{data.resource.name}</p>
                <span className="text-xsm-400">{data.allocatedEffort}hrs</span>
              </div>
            </div>
          ))}

          {item.allocations.length > 2 && (
            <div className="CounterBadge">+{item.allocations.length - 2}</div>
          )}
        </div>
        {assignShift && (
          <div
            className={`TaskResBox ${
              assignedResources.length > 0
                ? "ReAssignResWrap"
                : "selectResource"
            }`}
          >
            <div className="d-flex flex-wrap align-items-center gap-2">
              <div className="assignToItems">
                <TeachingPopover
                  positioning="below-start"
                  withArrow={false}
                  open={isPopoverOpen}
                  onOpenChange={(event, data) => setIsPopoverOpen(data.open)}
                >
                  <TeachingPopoverTrigger>
                    <Button
                      className="assignAvatarBtn"
                      onClick={() => setResourceOptions([])}
                    >
                      <Avatar icon={<AddPersonIcon />} name="" />
                    </Button>
                  </TeachingPopoverTrigger>
                  <TeachingPopoverSurface className="addCapacitySurface">
                    <TeachingPopoverHeader
                      className="addCapacityHeader"
                      icon={false}
                    >
                      Resources
                    </TeachingPopoverHeader>
                    <TeachingPopoverBody className="addCapacityBody">
                      <CustomInput
                        placeholder="Search"
                        handleChange={searchHandler}
                      />
                      <div className="mt-2 AddCapacityWrapper">
                        {resourceOptions.map((resource) => (
                          <AddCapacity
                            item={resource}
                            onInputChange={handleInputChange}
                            onActiveChange={handleActiveChange}
                          />
                        ))}
                      </div>
                    </TeachingPopoverBody>
                    <div className="addCapacityFooter">
                      <CustomButton
                        btnClass="d_btn d_btn_smallWhite me-10"
                        label="Cancel"
                        clickHandler={handleCancelResource}
                      />
                      <CustomButton
                        btnClass="d_btn d_btn_primary"
                        label="Confirm"
                        clickHandler={handleConfirm}
                      />
                    </div>
                  </TeachingPopoverSurface>
                </TeachingPopover>
                <p className="text-xsm-400 ms-1">Assign resource</p>
              </div>
              {assignedResources.map((res) => (
                <div className="assignToItems">
                  <Avatar
                    color="colorful"
                    name={res.label}
                    image={{ src: "" }}
                  />
                  <div>
                    <p className="text-xsm-400">{res.label}</p>
                    <span className="text-xsm-400">
                      {res.capacity ? `${res.capacity}hrs` : ""}
                    </span>
                  </div>
                  <div onClick={() => handleAssigneResource(res)}>
                    <FilterCross />
                  </div>
                </div>
              ))}
              <div className="CounterBadge">+3</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskCard;
